import script from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"

import "./BasePopup.vue?vue&type=style&index=0&id=2849a127&lang=scss"
import "./BasePopup.vue?vue&type=style&index=1&id=2849a127&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2849a127"]])

export default __exports__